<template>
  <div class="kpi-widget">
    <div class="kpi-label">{{ title }}</div>
    <div class="kpi-value">{{ primaryFormatted }}</div>
    <!-- Agregada debajo, más pequeña (solo en modo conteo + agregada) -->
    <div v-if="showMetricBelow" class="kpi-metric">
      <span class="kpi-metric-label">{{ metricLabel }}</span>
      <span class="kpi-metric-value">{{ fmt(metricValue) }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  value: { type: [Number, String], required: true },
  // Agregada opcional del KPI: valor, etiqueta y modo (solo-agregada vs conteo+agregada).
  metricValue: { type: [Number, String], default: null },
  metricLabel: { type: String, default: '' },
  metricOnly: { type: Boolean, default: false },
  // Formato del valor: 'euro0' = importe en € sin decimales (redondeado). Por defecto,
  // número con hasta 2 decimales.
  format: { type: String, default: null }
});

function fmt(v) {
  if (v === null || v === undefined || v === '') return v;
  if (typeof v === 'number') {
    if (props.format === 'euro0') {
      return Math.round(v).toLocaleString('es-ES', { maximumFractionDigits: 0, useGrouping: 'always' }) + ' €';
    }
    return v.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  return v;
}

const hasMetric = computed(() => props.metricValue !== null && props.metricValue !== undefined && props.metricValue !== '');
// Solo-agregada: la agregada ocupa el sitio del conteo (grande, como ahora).
const primaryFormatted = computed(() => (props.metricOnly && hasMetric.value) ? fmt(props.metricValue) : fmt(props.value));
// Conteo + agregada: el conteo es el valor grande y la agregada va debajo, pequeña.
const showMetricBelow = computed(() => hasMetric.value && !props.metricOnly);
</script>

<style scoped>
.kpi-widget {
  background: white;
  border-radius: 4px;
  padding: 12px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e8e8e8;
  min-height: 80px;
}

.kpi-label {
  font-size: 0.72rem;
  color: #888;
  font-weight: 500;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  line-height: 1.15;
  font-family: 'Source Sans Pro', sans-serif;
}

.kpi-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  font-family: 'Source Sans Pro', sans-serif;
}

.kpi-metric {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
  font-family: 'Source Sans Pro', sans-serif;
}

.kpi-metric-label {
  font-size: 0.56rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.kpi-metric-value {
  font-size: 0.8rem;
  font-weight: 600;
  color: #0b5394;
}
</style>
